import SettingsHeading from './SettingsHeading'

export default {
  SettingsHeading
}



// WEBPACK FOOTER //
// ./src/components/account/index.js